import React from 'react';
import {ExdsLayout, ExdsLayoutItem, ExdsText} from '@exds/core';
import './Footer.scss';

const Footer = () => {
  return (
    <ExdsLayout justifyContent="center" className="footer-layout">
      <ExdsLayoutItem>
        <ExdsText
          primitive="p"
          color="regular"
          textStyle="bodyMedium"
          className="footer-text"
        >
          Copyright © {new Date().getFullYear()} JPMorganChase
        </ExdsText>
      </ExdsLayoutItem>
    </ExdsLayout>
  );
};

export default Footer;

